const CentralizedNoticeIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2229_11101)" />
      <path
        d="M46.739 49.9996H25.8694C24.4281 49.9996 23.2607 48.8322 23.2607 47.3909C23.2607 45.9496 24.4281 44.7822 25.8694 44.7822"
        stroke="white"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M45.4348 20H25.8696C23.7083 20 21.9565 21.7517 21.9565 23.913V47.3913L24.5652 46.087H45.4348C46.8761 46.087 48.0435 44.9196 48.0435 43.4783V22.6087C48.0435 21.1674 46.8761 20 45.4348 20ZM40.2174 30.4348H31.087C30.367 30.4348 29.7826 29.8504 29.7826 29.1304C29.7826 28.4104 30.367 27.8261 31.087 27.8261H40.2174C40.9374 27.8261 41.5218 28.4104 41.5218 29.1304C41.5218 29.8504 40.9374 30.4348 40.2174 30.4348Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2229_11101"
          x1="34.5455"
          y1="2.70945e-07"
          x2="34.5455"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EA1225" />
          <stop offset="1" stop-color="#BA0B1B" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default CentralizedNoticeIconSubcategory
